import { cookieStorage, createStorage } from '@wagmi/core';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { base } from 'viem/chains';

// Get projectId from https://cloud.walletconnect.com
export const projectId = 'a5cb660549f27b2eed65e4f00fe5f461';

if (!projectId) throw new Error('Project ID is not defined');

// Set up the Wagmi Adapter (Config)
export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    storage: cookieStorage,
  }),
  ssr: true,
  projectId,
  networks: [base],
  // chains: [base],
});
